import api from "./Api";

class BloqueioLicencaService {
  GetBloqueioLicenca(payload) {
    return api.get("/v1/bloqueiolicenca/" + payload).then((response) => {
      return response.data;
    });
  }

  PostBloqueioLicenca(payload) {
    return api.post("/v1/bloqueiolicenca/", payload).then((response) => {
      return response.data;
    });
  }

  PutBloqueioLicenca(payload) {
    return api.put("/v1/bloqueiolicenca/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteBloqueioLicenca(payload) {
    return api.delete("/v1/bloqueiolicenca/" + payload).then((response) => {
      return response.data;
    });
  }

  GetBloqueioLicencaOData(payload) {
    return api.get("/OData/bloqueiolicenca" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new BloqueioLicencaService();
